import { ListRfqsReq } from '../repositories/drfq-types';
import { Drfq } from '../entities/drfq/domain';
import { DrfqHistoryStore } from '../store/drfq-history';
import { MergedSourcesFetcher } from './merged-sources-fetcher';
import { DrfqService } from './drfq';

interface RfqHistoryServiceDeps {
  drfqHistoryStore: DrfqHistoryStore;
  drfqService: DrfqService;
}

export class DrfqHistoryService {
  public fetcher: MergedSourcesFetcher<ListRfqsReq, Drfq>;

  constructor(deps: RfqHistoryServiceDeps) {
    this.fetcher = new MergedSourcesFetcher({
      fetchers: [deps.drfqService.listDrfqHistory],
      store: deps.drfqHistoryStore,
      pageSize: 50,
    });
  }
}
